export default __webpack_public_path__ + "static/media/mini-gasapp-logo.3f40c8d4.svg";